export function memoizeForHalfSecond(builder) {
    let memoized = null;
    return (...args)=>{
        if (!memoized) {
            setTimeout(()=>memoized = null, 500);
            memoized = builder(...args);
        }
        return memoized;
    };
}

//# sourceMappingURL=memoizeForHalfSecond.js.map